<template>
	<div class="season-switch-wrapper">
		<button type="button" class="btn-toggle-season" @click="toggleSeason">
			<font-awesome-icon :class="{ 'season-icon': true, 'icon-switch': animateIcon }" :icon="seasonIcon" :size="iconSize" />
		</button>
	</div>
</template>

<script>
	export default{
		name: 'SeasonSwitch',
		data () {
			return {
				seasons: {
					summer: 'sommer',
					winter: 'winter'
				},
				selectedSeason: this.$store.state.season,
				winterIcon: ['fal', 'snowflake'],
				summerIcon: ['fal', 'sun'],
				animationStart: null,
				animateIcon: false,
				animationDuration: 500,
			}
		},
		props: {
			iconSize: {
				type: String,
				default: '1x'
			}
		},
		methods: {
			toggleSeason () {
				// animate switch
				window.requestAnimationFrame(this.animateRotateToggle)

				if (this.selectedSeason === this.seasons.summer) {
					this.selectedSeason = this.seasons.winter
				} else {
					this.selectedSeason = this.seasons.summer
				}

				this.$store.dispatch('updateSeason', this.selectedSeason)
				this.$router.push({ name: 'home' })
			},
			animateRotateToggle (timestamp) {
				if (!this.animationStart) {
					this.animationStart = timestamp
				}

				let progress = timestamp - this.animationStart
				
				if (progress < this.animationDuration) {
					this.animateIcon = true
					window.requestAnimationFrame(this.animateRotateToggle)
				} else {
					this.animateIcon = false
					this.animationStart = null
				}
			}
		},
		computed: {
			seasonIcon () {
				if (this.$store.state.season == this.seasons.summer) {
					return this.winterIcon
				} else {
					return this.summerIcon
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.season-switch-wrapper{

		.btn-toggle-season{
			cursor: pointer;

			.season-icon{
				font-size: 1.5rem;

				&.fa-snowflake{
					color: get-color(primary);
				}
				&.fa-sun{
					color: get-color(secondary);
				}

				&.icon-switch{
					animation: seasonToggle .25s infinite;
				}

				@include breakpoint(medium) {
					font-size: 2rem;
				}
			}
		}
	}
</style>